import React from "react";
import {UserModuleMarketingInfo} from "./UserModuleMarketingInfo";
import {UserContentBase} from "./UserContentBase";


export class UserModuleMarketingContent extends UserContentBase {
    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("second")}
                <div className="section-body h-items">
                    <UserModuleMarketingInfo
                        userId={this.props.userId}
                        afterSuccessfulSubmit={this.handleAfterSuccessfulUserUpdated}
                    />
                </div>
            </section>
        )
    }
}
